var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9.90625V9.09375C1 6.42267 1 5.08713 1.72637 4.18822C1.85934 4.02366 2.00791 3.87277 2.16994 3.73772C3.05502 3 4.37001 3 7 3C9.62999 3 10.945 3 11.8301 3.73772C11.9921 3.87277 12.1407 4.02366 12.2736 4.18822C12.8349 4.88281 12.9625 5.83809 12.9915 7.46877L13.5267 7.20129C15.0834 6.41077 15.8618 6.01552 16.4309 6.37275C17 6.72998 17 7.61381 17 9.38146V9.61854C17 11.3862 17 12.27 16.4309 12.6273C15.8618 12.9845 15.0834 12.5892 13.5267 11.7987L12.9915 11.5312C12.9625 13.1619 12.8349 14.1172 12.2736 14.8118C12.1407 14.9763 11.9921 15.1272 11.8301 15.2623C10.945 16 9.62999 16 7 16C4.37001 16 3.05502 16 2.16994 15.2623C2.00791 15.1272 1.85934 14.9763 1.72637 14.8118C1 13.9129 1 12.5773 1 9.90625ZM10.2485 7.51804C10.7172 7.04208 10.7172 6.27042 10.2485 5.79446C9.7799 5.31851 9.0201 5.31851 8.55147 5.79446C8.08284 6.27042 8.08284 7.04208 8.55147 7.51804C9.0201 7.99399 9.7799 7.99399 10.2485 7.51804Z",
    fill: "#325CCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraMonitoring);
export default __webpack_public_path__ + "static/media/camera-monitoring.a4da89c3.svg";
export { ForwardRef as ReactComponent };